"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * API V1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PurchasePurchaseItemsSummaryInnerToJSON = exports.PurchasePurchaseItemsSummaryInnerFromJSONTyped = exports.PurchasePurchaseItemsSummaryInnerFromJSON = exports.instanceOfPurchasePurchaseItemsSummaryInner = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the PurchasePurchaseItemsSummaryInner interface.
 */
function instanceOfPurchasePurchaseItemsSummaryInner(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfPurchasePurchaseItemsSummaryInner = instanceOfPurchasePurchaseItemsSummaryInner;
function PurchasePurchaseItemsSummaryInnerFromJSON(json) {
    return PurchasePurchaseItemsSummaryInnerFromJSONTyped(json, false);
}
exports.PurchasePurchaseItemsSummaryInnerFromJSON = PurchasePurchaseItemsSummaryInnerFromJSON;
function PurchasePurchaseItemsSummaryInnerFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'productId': !(0, runtime_1.exists)(json, 'product_id') ? undefined : json['product_id'],
        'productName': !(0, runtime_1.exists)(json, 'product_name') ? undefined : json['product_name'],
        'quantity': !(0, runtime_1.exists)(json, 'quantity') ? undefined : json['quantity'],
        'size': !(0, runtime_1.exists)(json, 'size') ? undefined : json['size'],
        'color': !(0, runtime_1.exists)(json, 'color') ? undefined : json['color'],
        'productImage': !(0, runtime_1.exists)(json, 'product_image') ? undefined : json['product_image'],
        'unitPrice': !(0, runtime_1.exists)(json, 'unit_price') ? undefined : json['unit_price'],
        'subtotal': !(0, runtime_1.exists)(json, 'subtotal') ? undefined : json['subtotal'],
    };
}
exports.PurchasePurchaseItemsSummaryInnerFromJSONTyped = PurchasePurchaseItemsSummaryInnerFromJSONTyped;
function PurchasePurchaseItemsSummaryInnerToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'product_id': value.productId,
        'product_name': value.productName,
        'quantity': value.quantity,
        'size': value.size,
        'color': value.color,
        'product_image': value.productImage,
        'unit_price': value.unitPrice,
        'subtotal': value.subtotal,
    };
}
exports.PurchasePurchaseItemsSummaryInnerToJSON = PurchasePurchaseItemsSummaryInnerToJSON;
